/**
 * Member group utilities for Firestore collection/document naming.
 *
 * 정책:
 * - 그룹 'A' 또는 미지정(undefined/null/empty)은 기존(레거시) 경로를 그대로 사용
 * - 그룹 'B' 이상은 `${base}_${group}` 형태로 컬렉션명을 분리 (예: generalAssignmentStatuses_B)
 */
export function normalizeMemberGroup(memberGroup?: string): string {
  const g = (memberGroup || 'A').toString().trim().toUpperCase();
  return g || 'A';
}

export function withMemberGroup(baseCollectionName: string, memberGroup?: string): string {
  const g = normalizeMemberGroup(memberGroup);
  if (g === 'A') return baseCollectionName;
  return `${baseCollectionName}_${g}`;
}


